import React from 'react';

import { QuestionBubble } from '../QuestionBubble';
import { TestID, visitResourcesClassName } from './constants';

const MedicationManagementQuestionBubble: React.FC = () => {
  return (
    <QuestionBubble
      dataTestID={TestID}
      popoverTitle="Medication management"
      sections={[
        {
          sectionTitle: 'What is medication management?',
          sectionBody: (
            <div>
              This service, offered as a benefit by the employer through Modern Health, allows
              clients to work directly with a provider to discuss medication needs in relation to
              their mental health. Clients must first complete an eligibility check to get access to
              this benefit.
            </div>
          ),
        },
        {
          sectionTitle: 'What do these terms mean?',
          sectionBody: (
            <>
              <div>
                <span className="font-bold">Available:</span> This member's employer offers a
                psychiatry and medication management benefit through Modern Health.
              </div>

              <div className="mt-4">
                <span className="font-bold">Not available:</span> This client’s employer does not
                offer a psychiatry and medication management benefit.
              </div>
            </>
          ),
        },
        {
          sectionBody: (
            <a
              className={visitResourcesClassName}
              target="_blank"
              rel="noopener noreferrer"
              href="https://modernhealththerapists.notion.site/modernhealththerapists/Psychiatry-Medication-Management-Guidelines-0ae070fd8f6541b1b444990a82d438ab"
            >
              Visit resources
            </a>
          ),
        },
      ]}
    />
  );
};

export default MedicationManagementQuestionBubble;
